var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"absolute w-full z-3 -bottom-1"},'div',_vm.$attrs,false),[_c('div',{staticClass:"w-0 h-full",style:({ width: _vm.progress + '%', backgroundColor: _vm.fillColor })})])}
var staticRenderFns = []

export { render, staticRenderFns }